var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coupon-rules"},[_vm._v(" 这个是优惠卷使用规则 ")])}
var staticRenderFns = []

export { render, staticRenderFns }